import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import Shortcut from '../utils/Shortcut';
import { isSimpleGroup } from '../objects/guards';

class ToolUngroup extends Tool {
  static toolName = 'Ungroup objects';
  static shortcut = new Shortcut('Cmd+Shift+G');

  static action({ controller, selection }: IToolActionInput) {
    if (!isSimpleGroup(selection)) {
      console.warn('Cannot ungroup, selection is not a group');
      return;
    }

    selection.deleted(controller);
    selection.toActiveSelection(controller);

    // Force object toolbar to update.
    controller.actionShowObjectToolbar();
    this.toolActionComplete({ controller });
  }

  static enabled({ selection }: IToolEnabledInput) {
    return !!(selection && !selection.isLocked && selection.type === 'group');
  }

  static buttonComponent() {
    return simpleToolButton(ToolUngroup, 'fa-regular fa-object-ungroup');
  }
}

export default ToolUngroup;
